import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { MusicVideoClip } from 'fym-shared/src/music24/musicVideoDoc';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { footageMessages } from '../messages/footageMessages';
import { panelMessages } from '../messages/panelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SheetClipStripProps {
  clips: readonly MusicVideoClip[];
  selectedId: string | null;
  onSelect: (clipId: string) => void;
}

/** The clips of a section in the phone sheet (design f2), sideways. A tap selects one and plays it. */
const SheetClipStripComponent: React.FC<SheetClipStripProps> = ({ clips, selectedId, onSelect }) => {
  const intl = useIntl();
  const { footage, transport, select } = useMusicVideoEditor();
  return (
    <div className={styles.hScroll}>
      {clips.map((clip) => {
        const view = footage.lookup(clip.source);
        return (
          <button
            key={clip.id}
            type="button"
            className={clsx(styles.clipCard, clip.id === selectedId && styles.clipCardOn)}
            style={
              view === null || view.posterUrl === null ? undefined : { backgroundImage: `url("${view.posterUrl}")` }
            }
            aria-pressed={clip.id === selectedId}
            aria-label={view?.label ?? ''}
            onClick={() => {
              onSelect(clip.id);
              select({ kind: 'clip', id: clip.id });
              transport.seek(clip.startSec);
            }}
          >
            {clip.source.kind === 'footage' && (
              <span className={clsx(styles.clipSource, styles.clipSourceMine)}>
                {intl.formatMessage(footageMessages.sourceYours)}
              </span>
            )}
            <span className={styles.clipDuration}>
              {intl.formatMessage(panelMessages.phoneClipLength, { seconds: (clip.endSec - clip.startSec).toFixed(1) })}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export const SheetClipStrip = TypedMemo(SheetClipStripComponent);
